








































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { DataTableSetting } from './DataTableSetting';
import { ContractDataTableSetting } from './ContractDataTableSetting';
import { SearchContractDataTableSetting } from './SearchContractDataTableSetting';
import { DataTableField } from './DataTableField';
import { DataTableButton } from './DataTableButton';
import { ActionEnum } from './ActionEnum';
import { FieldEnum } from './FieldEnum';
import TireLocationNoTableField from '@/components/tire/TireLocationNoTableField.vue';

import { DataBus, TireStoringContract, InputError, Location } from '@/models';

@Component({
  components: {
    TireLocationNoTableField
  },
})
export default class DataTable extends Vue {
  @Prop() private setting!: DataTableSetting;
  @Prop() private selectable!: Boolean;
  @Prop() private selectMode!: String;
  private ActionEnum = ActionEnum;
  private FieldEnum = FieldEnum;

  private checked: boolean = false;
  private indeterminate: boolean = false;
  private rowSelected: string = '';
  private settingLocationContractMap: Map< Location, string[]> = new Map<Location, string[]>();

  onRowSelected(items: any) {
    this.$emit('itemsSelected', items);
  }

  private checkItem(item: any) {
    this.setting.selected.push(item.id);
  }

  private getDate(date: number): string {
    return date ? this.$moment(date).format('YYYY-MM-DD') : '';
  }

  private getDateText(date: Date): string {
    return date ? this.$moment(date).format('YYYY-MM-DD') + " ("+ this.getDayOfWeek(new Date(date).getUTCDay()) + ")" : '';
  }

  private getDayOfWeek(value: number) {
    switch (value) {
      case 0: return this.$t("common.day_of_week.sunday").toString();
      case 1: return this.$t("common.day_of_week.monday").toString();
      case 2: return this.$t("common.day_of_week.tuesday").toString();
      case 3: return this.$t("common.day_of_week.wednesday").toString();
      case 4: return this.$t("common.day_of_week.thursday").toString();
      case 5: return this.$t("common.day_of_week.friday").toString();
      case 6: return this.$t("common.day_of_week.saturday").toString();
    }
  }

  private getDateTime(dateTime: number): string {
    return dateTime ? this.$moment(dateTime).format('YYYY-MM-DD HH:mm') : '';
  }

  private getDayLeft(date: any): string {
    if (date) {
      const currentDate = this.$moment();
      const endDate = this.$moment(date);
      const dayLeft: number = endDate.diff(currentDate, 'd');
      return dayLeft.toString();
    }
    return '';
  }

  private rowClass(item: any, type: string) {
    // Type could be row or row-empty
    if (type === 'row') {
      this.settingLocationContractMap.forEach((value,key) => {
        if(value.some(id => id === item.id)){
          item.rackLocation = key.shelf1;
          item.columnLocation = key.shelf2;
          item.rowLocation = key.shelf3;
        }
      });

      for (const id of this.setting.selected) {
        if (id === item.id) {
          return 'row-color';
        }
      }
    }
  }

  private getBadgeClass(value: number): any {
    return {
      badge_1: value === 1,
      badge_2: value === 2,
      badge_3: value === 3,
      badge_4: value === 4,
      badge_5: value === 5,
    };
  }

  private changePageSize(size: number) {
    this.setting.perPage = size;
    this.setting.currentPage = 1;
  }

  private buttonHandle(button: DataTableButton, item: any) {
    // Dark magic
    if (button.method) {
      return button.method(item);
    } else if (button.routerLink) {
      this.$router.push(button.routerLink + '/' + item.id);
      return;
    }
  }

  private refreshTable() {
    (this.$refs.table as any).refresh();
    for (const element of (this.$refs.table as any).$el.children[1].children) {
      element.className = '';
    }
    this.setting.selected = [];
  }

  private rowClickHandle(item: any, index: number, event: any) {
    if (this.setting.isRowClickSelected) {
      // Row click = select item
      let itemIndex = -1;
      this.setting.selected.forEach((element) => {
        if (item.id === element) {
          itemIndex = this.setting.selected.indexOf(element);
          if (itemIndex >= 0) {
            this.setting.selected.splice(itemIndex, 1);
          }
          return;
        }
      });
      if (itemIndex < 0) {
        this.setting.selected.push(item.id);
      }
    } else if (this.setting.rowClickFunction) {
      // Row click = load function
      this.setting.rowClickFunction(item);
    } else if (this.setting.isRowClickSelected === undefined) {
      // click one row
      // if( this.rowSelected === '' || item.id !== this.rowSelected) {
      //   this.rowSelected = item.id;
      // } else {
      //   this.rowSelected = '';
      // }
    }
  }

  private selectItem(id: string) {
    const itemIndex = this.setting.selected.indexOf(id);
    if (itemIndex < 0) {
      this.setting.selected.push(id);    
    }
  }

  private selectItems(ids: string[]) {
    ids.forEach((id) => this.selectItem(id));
  }

  private deselectAll() {
    this.setting.selected = [];
  }

  private customHandle(htmlFunction: Function, item: any): string {
    return htmlFunction(item);
  }

  private refreshedHandle() {
    if (this.setting instanceof ContractDataTableSetting) {
      this.reloadPickupDate(this.setting.contracts);
    } else if (this.setting instanceof SearchContractDataTableSetting) {
      this.checkContractMatched(this.setting);
    }
    if (!(this.$refs.table as any).computedItems || (this.$refs.table as any).computedItems.length === 0) {
      this.setting.totalRows = 0;
    }
  }

  private reloadPickupDate(contracts: TireStoringContract[]) {
    const allCurrentPageItem = (this.$refs.table as any).computedItems;
    allCurrentPageItem.forEach((item: any) => {
      const currentContract = contracts.find((contract) => contract.id === item.id);
      if (currentContract) {
        item.pickupDate = currentContract.pickupDate;
      }
    });
  }
  
  private checkContractMatched(setting: SearchContractDataTableSetting) {
    const allCurrentPageItem = (this.$refs.table as any).computedItems;
    if (!setting.filter.trim()) {
      return;
    }
    if (setting.onContractMatched
      && allCurrentPageItem.length === 1
      && (setting.filter.trim() === allCurrentPageItem[0].slipNo
        || setting.filter.trim() === allCurrentPageItem[0].customer.name
        || setting.filter.trim() === allCurrentPageItem[0].customer.furigana
        || setting.filter.trim() === allCurrentPageItem[0].customer.phoneNumber
        || setting.filter.trim() === allCurrentPageItem[0].customer.mobileNumber)) {      
      setting.onContractMatched(allCurrentPageItem[0].id);
    }
  }

  private updateLocationNo(tireContract: any) {
    const dataTable = (this.$refs.table as any).computedItems;
    this.$emit('updateLocationNo', tireContract, dataTable);
  }

  private isEdit(id: any) {
    const dataTable = (this.$refs.table as any).computedItems.find((item: any) => item.id === id);
    dataTable['isEdit'] = true;
  }

  private onInputChange(field: string, id: any) {
      const dataTable = (this.$refs.table as any).computedItems.find((item: any) => item.id === id);
      const inputError = dataTable.errors.find((e: any) => e.field === field);
      if (inputError) {
          inputError.isError = undefined;
      }
  }
  private setLocation(location: Location, settingContracts: string[]) {  
    this.settingLocationContractMap.set(location,settingContracts);
    
  }

}
